import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
// import firebase from 'firebase'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  // var firebaseConfig = {
  //   apiKey: "AIzaSyD79KqP6srLjqE5XOliIqZma4LeQawwRvA",
  //   authDomain: "allknowingandallpowerfulgame.firebaseapp.com",
  //   databaseURL: "https://allknowingandallpowerfulgame.firebaseio.com",
  //   projectId: "allknowingandallpowerfulgame",
  //   storageBucket: "allknowingandallpowerfulgame.appspot.com",
  //   messagingSenderId: "222066599764",
  //   appId: "1:222066599764:web:a20da834c1193ab2a70ac1",
  //   measurementId: "G-B61SMT7BBN"
  // };
  // // Initialize Firebase
  // firebase.initializeApp(firebaseConfig);
  // firebase.analytics();
